import { useCatalogContext } from '../../state/Catalog';
import { deriveTelemetryPage } from '../../utils/deriveTelemetryPage';
import { useCatalogSearchBarContext } from '../CatalogSearchBar';

export const useCatalogSearchHeader = () => {
  const { selectedCategory } = useCatalogContext();
  const { handleOnOpen } = useCatalogSearchBarContext();
  const handleClickModifySearch = () => {
    handleOnOpen({ source: 'modifyButton', page: deriveTelemetryPage({ product: null, selectedCategory, view: 'productGrid' }) });
  };
  return {
    handleClickModifySearch
  };
};
